// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DailyReview.css - Single-screen mobile view (matches Order Taking / Objection Handling) */

.dr-app-container,
.dr-app-container * {
  box-sizing: border-box;
}

.dr-app-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  height: 100dvh;
  min-height: -webkit-fill-available;
  width: 100vw;
  padding: 0;
  margin: 0;
  overflow: hidden;
  background: #0a0a0a;
  font-family: 'Outfit', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #ffffff;
  text-size-adjust: 100%;
}

/* Phone frame — identical geometry to the Order Taking screen */
.dr-phone-mockup {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 30px;
  width: 400px;
  max-width: 100vw;
  height: 750px;
  max-height: 100vh;
  padding: 20px 18px 0 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  gap: 10px;
}

.dr-phone-mockup::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
  pointer-events: none;
}

.dr-phone-mockup > * {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
}

/* ---------- Header ---------- */
.dr-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  gap: 2px;
}

.dr-logo {
  width: 100px;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.25));
}

.dr-title {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 0.06em;
  color: #ffffff;
}

.dr-subtitle {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #b0bec5;
}

/* ---------- Meta pills ---------- */
.dr-meta-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  width: 100%;
}

.dr-meta-pill {
  font-size: 10.5px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  padding: 4px 10px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  white-space: nowrap;
}

.dr-emp-pill {
  background: rgba(56, 189, 248, 0.2);
  color: #7dd3fc;
  border-color: rgba(56, 189, 248, 0.45);
  /* Employee names are longer than the ids this pill used to hold */
  max-width: 45%;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------- Analytics block ---------- */
.dr-analytics {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dr-analytics-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #cbd5e1;
}

.dr-heading-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dr-live-dot {
  width: 8px;
  height: 8px;
  background-color: #10b981;
  border-radius: 50%;
  box-shadow: 0 0 10px #10b981;
  animation: drPulseDot 2s infinite ease-in-out;
}

@keyframes drPulseDot {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.3); opacity: 0.4; }
}

.dr-sync-tag {
  font-size: 9.5px;
  font-weight: 600;
  color: #94a3b8;
}

/* Revenue strip */
.dr-revenue-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(56, 189, 248, 0.28);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.dr-revenue-left {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.dr-revenue-label {
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
}

.dr-revenue-val {
  font-size: 24px;
  font-weight: 800;
  line-height: 1.1;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dr-revenue-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
}

.dr-currency-tag {
  white-space: nowrap;
  font-size: 9.5px;
  font-weight: 700;
  background: rgba(16, 185, 129, 0.2);
  color: #34d399;
  padding: 3px 9px;
  border-radius: 20px;
  border: 1px solid rgba(16, 185, 129, 0.35);
}

.dr-products-stat {
  font-size: 9.5px;
  color: #cbd5e1;
  font-weight: 500;
  text-align: right;
}

.dr-products-stat strong {
  color: #ffffff;
}

/* 2x2 KPI grid */
.dr-kpi-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.dr-kpi-tile {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 12px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.dr-tile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.dr-tile-label {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #94a3b8;
  white-space: nowrap;
}

.dr-tile-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dr-tile-dot.blue { background-color: #38bdf8; box-shadow: 0 0 8px rgba(56, 189, 248, 0.6); }
.dr-tile-dot.emerald { background-color: #10b981; box-shadow: 0 0 8px rgba(16, 185, 129, 0.6); }
.dr-tile-dot.amber { background-color: #fbbf24; box-shadow: 0 0 8px rgba(251, 191, 36, 0.6); }
.dr-tile-dot.purple { background-color: #a855f7; box-shadow: 0 0 8px rgba(168, 85, 247, 0.6); }

.dr-tile-number {
  font-size: 20px;
  font-weight: 800;
  line-height: 1;
  color: #ffffff;
}

.dr-tile-number.emerald { color: #34d399; }
.dr-tile-number.amber { color: #fbbf24; }
.dr-tile-number.purple { color: #c084fc; }

.dr-empty-analytics {
  padding: 14px 12px;
  text-align: center;
  color: #cbd5e1;
  font-size: 11.5px;
  line-height: 1.4;
  border: 1px dashed rgba(255, 255, 255, 0.22);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.05);
}

/* ---------- Call section ---------- */
.dr-call-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  gap: 8px;
}

.dr-call-orb {
  width: 84px;
  height: 84px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0;
  flex-shrink: 0;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.dr-call-orb.start {
  background: linear-gradient(135deg, #4CAF50 0%, #2e7d32 100%);
  box-shadow: 0 0 28px rgba(34, 197, 94, 0.4), inset 0 2px 4px rgba(255, 255, 255, 0.3);
}

.dr-call-orb.end {
  background: linear-gradient(135deg, #f44336 0%, #b91c1c 100%);
  box-shadow: 0 0 28px rgba(239, 68, 68, 0.4), inset 0 2px 4px rgba(255, 255, 255, 0.3);
}

.dr-call-orb:hover { transform: scale(1.05); }
.dr-call-orb:active { transform: scale(0.95); }

.dr-call-orb.connecting {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  cursor: not-allowed;
  opacity: 0.85;
  animation: drOrbPulse 2s infinite;
}

@keyframes drOrbPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.dr-orb-ring {
  position: absolute;
  width: 104px;
  height: 104px;
  border-radius: 50%;
  border: 2px dashed rgba(255, 255, 255, 0.25);
  animation: drSpinRing 12s linear infinite;
  pointer-events: none;
}

@keyframes drSpinRing {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.dr-orb-icon svg {
  width: 36px;
  height: 36px;
  color: #ffffff;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.dr-call-status-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #e2e8f0;
  text-align: center;
}

/* Audio visualizer waves */
.dr-voice-waves {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 20px;
}

.dr-wave {
  width: 4px;
  background: #38bdf8;
  border-radius: 6px;
  animation: drBounceWave 1s ease-in-out infinite alternate;
}

.dr-wave:nth-child(1) { animation-delay: 0.1s; height: 9px; }
.dr-wave:nth-child(2) { animation-delay: 0.3s; height: 17px; background: #a855f7; }
.dr-wave:nth-child(3) { animation-delay: 0.2s; height: 20px; background: #22c55e; }
.dr-wave:nth-child(4) { animation-delay: 0.4s; height: 13px; }
.dr-wave:nth-child(5) { animation-delay: 0.15s; height: 16px; }

@keyframes drBounceWave {
  0% { transform: scaleY(0.3); opacity: 0.5; }
  100% { transform: scaleY(1.3); opacity: 1; }
}

.dr-enable-audio-btn {
  font-family: inherit;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #0f172a;
  background: #fbbf24;
  border: none;
  border-radius: 20px;
  padding: 7px 16px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(251, 191, 36, 0.35);
}

.dr-enable-audio-btn:active {
  transform: scale(0.96);
}

.dr-error-text {
  color: #fca5a5;
  text-align: center;
  font-size: 11.5px;
  font-weight: 600;
  padding: 0 8px;
}

/* ---------- Bot ---------- */
.dr-bot-container {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  padding: 0 16px 16px;
}

.dr-bot-image {
  width: 110px;
  max-width: 40%;
  height: auto;
  border-radius: 50%;
  filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.35));
}

/* TABLET/LAPTOP: 701px–1200px */
@media (min-width: 701px) and (max-width: 1200px) {
  .dr-phone-mockup {
    width: 90vw;
    max-width: 480px;
    height: 92vh;
  }
}

/* MOBILE: <=700px — full-bleed single screen, no scrolling */
@media (max-width: 700px) {
  .dr-app-container {
    height: 100vh;
    height: 100dvh;
    width: 100vw;
    padding: 0;
  }
  .dr-phone-mockup {
    width: 100vw !important;
    max-width: 100vw !important;
    height: 100vh !important;
    height: 100dvh !important;
    max-height: 100dvh !important;
    border-radius: 0 !important;
    padding: 16px 12px 0 12px;
    box-shadow: none;
    gap: 8px;
  }
  .dr-logo { width: 86px; }
  .dr-title { font-size: 15.5px; }
  .dr-subtitle { font-size: 10px; }
  .dr-bot-container { padding: 0 12px 12px; }
  .dr-bot-image { width: 100px; }
}

/* SHORT SCREENS: keep everything inside one screen */
@media (max-height: 700px) {
  .dr-logo { width: 74px; }
  .dr-title { font-size: 14px; }
  .dr-revenue-val { font-size: 20px; }
  .dr-tile-number { font-size: 17px; }
  .dr-call-orb { width: 70px; height: 70px; }
  .dr-orb-ring { width: 88px; height: 88px; }
  .dr-orb-icon svg { width: 30px; height: 30px; }
  .dr-bot-image { width: 84px; }
  .dr-bot-container { padding: 0 12px 8px; }
}

@media (max-height: 600px) {
  .dr-logo { width: 62px; }
  .dr-subtitle { display: none; }
  .dr-revenue-val { font-size: 18px; }
  .dr-kpi-tile { padding: 6px 8px; }
  .dr-tile-number { font-size: 15px; }
  .dr-call-orb { width: 60px; height: 60px; }
  .dr-orb-ring { width: 76px; height: 76px; }
  .dr-orb-icon svg { width: 26px; height: 26px; }
  .dr-bot-container { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/DailyReview.css"],"names":[],"mappings":"AAAA,4FAA4F;;AAG5F;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,sEAAsE;EACtE,cAAc;EAEd,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,yDAAgD;EAChD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;+FAC6F;EAC7F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,sCAAsC;EACtC,kEAAkE;EAClE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,WAAW,mBAAmB,EAAE,UAAU,EAAE;EAC5C,MAAM,qBAAqB,EAAE,YAAY,EAAE;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oBAAoB,yBAAyB,EAAE,2CAA2C,EAAE;AAC5F,uBAAuB,yBAAyB,EAAE,2CAA2C,EAAE;AAC/F,qBAAqB,yBAAyB,EAAE,2CAA2C,EAAE;AAC7F,sBAAsB,yBAAyB,EAAE,2CAA2C,EAAE;;AAE9F;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,0BAA0B,cAAc,EAAE;AAC1C,wBAAwB,cAAc,EAAE;AACxC,yBAAyB,cAAc,EAAE;;AAEzC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;EAC5C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,qFAAqF;AACvF;;AAEA;EACE,6DAA6D;EAC7D,qFAAqF;AACvF;;AAEA,qBAAqB,sBAAsB,EAAE;AAC7C,sBAAsB,sBAAsB,EAAE;;AAE9C;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,4CAA4C;EAC5C,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA,wBAAwB,qBAAqB,EAAE,WAAW,EAAE;AAC5D,wBAAwB,qBAAqB,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAClF,wBAAwB,qBAAqB,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAClF,wBAAwB,qBAAqB,EAAE,YAAY,EAAE;AAC7D,wBAAwB,sBAAsB,EAAE,YAAY,EAAE;;AAE9D;EACE,KAAK,sBAAsB,EAAE,YAAY,EAAE;EAC3C,OAAO,sBAAsB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA,gCAAgC;AAChC;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,aAAa;IACb,cAAc;IACd,YAAY;IACZ,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;IAC7B,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,QAAQ;EACV;EACA,WAAW,WAAW,EAAE;EACxB,YAAY,iBAAiB,EAAE;EAC/B,eAAe,eAAe,EAAE;EAChC,oBAAoB,oBAAoB,EAAE;EAC1C,gBAAgB,YAAY,EAAE;AAChC;;AAEA,qDAAqD;AACrD;EACE,WAAW,WAAW,EAAE;EACxB,YAAY,eAAe,EAAE;EAC7B,kBAAkB,eAAe,EAAE;EACnC,kBAAkB,eAAe,EAAE;EACnC,eAAe,WAAW,EAAE,YAAY,EAAE;EAC1C,eAAe,WAAW,EAAE,YAAY,EAAE;EAC1C,mBAAmB,WAAW,EAAE,YAAY,EAAE;EAC9C,gBAAgB,WAAW,EAAE;EAC7B,oBAAoB,mBAAmB,EAAE;AAC3C;;AAEA;EACE,WAAW,WAAW,EAAE;EACxB,eAAe,aAAa,EAAE;EAC9B,kBAAkB,eAAe,EAAE;EACnC,eAAe,gBAAgB,EAAE;EACjC,kBAAkB,eAAe,EAAE;EACnC,eAAe,WAAW,EAAE,YAAY,EAAE;EAC1C,eAAe,WAAW,EAAE,YAAY,EAAE;EAC1C,mBAAmB,WAAW,EAAE,YAAY,EAAE;EAC9C,oBAAoB,aAAa,EAAE;AACrC","sourcesContent":["/* DailyReview.css - Single-screen mobile view (matches Order Taking / Objection Handling) */\n@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');\n\n.dr-app-container,\n.dr-app-container * {\n  box-sizing: border-box;\n}\n\n.dr-app-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  height: 100dvh;\n  min-height: -webkit-fill-available;\n  width: 100vw;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  background: #0a0a0a;\n  font-family: 'Outfit', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  color: #ffffff;\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\n/* Phone frame — identical geometry to the Order Taking screen */\n.dr-phone-mockup {\n  background-image: url('./assets/background.png');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-radius: 30px;\n  width: 400px;\n  max-width: 100vw;\n  height: 750px;\n  max-height: 100vh;\n  padding: 20px 18px 0 18px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  gap: 10px;\n}\n\n.dr-phone-mockup::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),\n              radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.dr-phone-mockup > * {\n  position: relative;\n  z-index: 2;\n  flex-shrink: 0;\n}\n\n/* ---------- Header ---------- */\n.dr-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  width: 100%;\n  gap: 2px;\n}\n\n.dr-logo {\n  width: 100px;\n  height: auto;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.25));\n}\n\n.dr-title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  color: #ffffff;\n}\n\n.dr-subtitle {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #b0bec5;\n}\n\n/* ---------- Meta pills ---------- */\n.dr-meta-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  width: 100%;\n}\n\n.dr-meta-pill {\n  font-size: 10.5px;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.1);\n  color: #e2e8f0;\n  padding: 4px 10px;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  white-space: nowrap;\n}\n\n.dr-emp-pill {\n  background: rgba(56, 189, 248, 0.2);\n  color: #7dd3fc;\n  border-color: rgba(56, 189, 248, 0.45);\n  /* Employee names are longer than the ids this pill used to hold */\n  max-width: 45%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ---------- Analytics block ---------- */\n.dr-analytics {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dr-analytics-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #cbd5e1;\n}\n\n.dr-heading-left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.dr-live-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #10b981;\n  border-radius: 50%;\n  box-shadow: 0 0 10px #10b981;\n  animation: drPulseDot 2s infinite ease-in-out;\n}\n\n@keyframes drPulseDot {\n  0%, 100% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.3); opacity: 0.4; }\n}\n\n.dr-sync-tag {\n  font-size: 9.5px;\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n/* Revenue strip */\n.dr-revenue-strip {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 14px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(56, 189, 248, 0.28);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.dr-revenue-left {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.dr-revenue-label {\n  font-size: 9.5px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.dr-revenue-val {\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1.1;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dr-revenue-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.dr-currency-tag {\n  white-space: nowrap;\n  font-size: 9.5px;\n  font-weight: 700;\n  background: rgba(16, 185, 129, 0.2);\n  color: #34d399;\n  padding: 3px 9px;\n  border-radius: 20px;\n  border: 1px solid rgba(16, 185, 129, 0.35);\n}\n\n.dr-products-stat {\n  font-size: 9.5px;\n  color: #cbd5e1;\n  font-weight: 500;\n  text-align: right;\n}\n\n.dr-products-stat strong {\n  color: #ffffff;\n}\n\n/* 2x2 KPI grid */\n.dr-kpi-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.dr-kpi-tile {\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.13);\n  border-radius: 12px;\n  padding: 8px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.dr-tile-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.dr-tile-label {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.dr-tile-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.dr-tile-dot.blue { background-color: #38bdf8; box-shadow: 0 0 8px rgba(56, 189, 248, 0.6); }\n.dr-tile-dot.emerald { background-color: #10b981; box-shadow: 0 0 8px rgba(16, 185, 129, 0.6); }\n.dr-tile-dot.amber { background-color: #fbbf24; box-shadow: 0 0 8px rgba(251, 191, 36, 0.6); }\n.dr-tile-dot.purple { background-color: #a855f7; box-shadow: 0 0 8px rgba(168, 85, 247, 0.6); }\n\n.dr-tile-number {\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 1;\n  color: #ffffff;\n}\n\n.dr-tile-number.emerald { color: #34d399; }\n.dr-tile-number.amber { color: #fbbf24; }\n.dr-tile-number.purple { color: #c084fc; }\n\n.dr-empty-analytics {\n  padding: 14px 12px;\n  text-align: center;\n  color: #cbd5e1;\n  font-size: 11.5px;\n  line-height: 1.4;\n  border: 1px dashed rgba(255, 255, 255, 0.22);\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n/* ---------- Call section ---------- */\n.dr-call-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  flex: 1 1 auto;\n  min-height: 0;\n  gap: 8px;\n}\n\n.dr-call-orb {\n  width: 84px;\n  height: 84px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 0;\n  flex-shrink: 0;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n\n.dr-call-orb.start {\n  background: linear-gradient(135deg, #4CAF50 0%, #2e7d32 100%);\n  box-shadow: 0 0 28px rgba(34, 197, 94, 0.4), inset 0 2px 4px rgba(255, 255, 255, 0.3);\n}\n\n.dr-call-orb.end {\n  background: linear-gradient(135deg, #f44336 0%, #b91c1c 100%);\n  box-shadow: 0 0 28px rgba(239, 68, 68, 0.4), inset 0 2px 4px rgba(255, 255, 255, 0.3);\n}\n\n.dr-call-orb:hover { transform: scale(1.05); }\n.dr-call-orb:active { transform: scale(0.95); }\n\n.dr-call-orb.connecting {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  cursor: not-allowed;\n  opacity: 0.85;\n  animation: drOrbPulse 2s infinite;\n}\n\n@keyframes drOrbPulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n}\n\n.dr-orb-ring {\n  position: absolute;\n  width: 104px;\n  height: 104px;\n  border-radius: 50%;\n  border: 2px dashed rgba(255, 255, 255, 0.25);\n  animation: drSpinRing 12s linear infinite;\n  pointer-events: none;\n}\n\n@keyframes drSpinRing {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.dr-orb-icon svg {\n  width: 36px;\n  height: 36px;\n  color: #ffffff;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));\n}\n\n.dr-call-status-label {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #e2e8f0;\n  text-align: center;\n}\n\n/* Audio visualizer waves */\n.dr-voice-waves {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  height: 20px;\n}\n\n.dr-wave {\n  width: 4px;\n  background: #38bdf8;\n  border-radius: 6px;\n  animation: drBounceWave 1s ease-in-out infinite alternate;\n}\n\n.dr-wave:nth-child(1) { animation-delay: 0.1s; height: 9px; }\n.dr-wave:nth-child(2) { animation-delay: 0.3s; height: 17px; background: #a855f7; }\n.dr-wave:nth-child(3) { animation-delay: 0.2s; height: 20px; background: #22c55e; }\n.dr-wave:nth-child(4) { animation-delay: 0.4s; height: 13px; }\n.dr-wave:nth-child(5) { animation-delay: 0.15s; height: 16px; }\n\n@keyframes drBounceWave {\n  0% { transform: scaleY(0.3); opacity: 0.5; }\n  100% { transform: scaleY(1.3); opacity: 1; }\n}\n\n.dr-enable-audio-btn {\n  font-family: inherit;\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: #0f172a;\n  background: #fbbf24;\n  border: none;\n  border-radius: 20px;\n  padding: 7px 16px;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(251, 191, 36, 0.35);\n}\n\n.dr-enable-audio-btn:active {\n  transform: scale(0.96);\n}\n\n.dr-error-text {\n  color: #fca5a5;\n  text-align: center;\n  font-size: 11.5px;\n  font-weight: 600;\n  padding: 0 8px;\n}\n\n/* ---------- Bot ---------- */\n.dr-bot-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  width: 100%;\n  padding: 0 16px 16px;\n}\n\n.dr-bot-image {\n  width: 110px;\n  max-width: 40%;\n  height: auto;\n  border-radius: 50%;\n  filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.35));\n}\n\n/* TABLET/LAPTOP: 701px–1200px */\n@media (min-width: 701px) and (max-width: 1200px) {\n  .dr-phone-mockup {\n    width: 90vw;\n    max-width: 480px;\n    height: 92vh;\n  }\n}\n\n/* MOBILE: <=700px — full-bleed single screen, no scrolling */\n@media (max-width: 700px) {\n  .dr-app-container {\n    height: 100vh;\n    height: 100dvh;\n    width: 100vw;\n    padding: 0;\n  }\n  .dr-phone-mockup {\n    width: 100vw !important;\n    max-width: 100vw !important;\n    height: 100vh !important;\n    height: 100dvh !important;\n    max-height: 100dvh !important;\n    border-radius: 0 !important;\n    padding: 16px 12px 0 12px;\n    box-shadow: none;\n    gap: 8px;\n  }\n  .dr-logo { width: 86px; }\n  .dr-title { font-size: 15.5px; }\n  .dr-subtitle { font-size: 10px; }\n  .dr-bot-container { padding: 0 12px 12px; }\n  .dr-bot-image { width: 100px; }\n}\n\n/* SHORT SCREENS: keep everything inside one screen */\n@media (max-height: 700px) {\n  .dr-logo { width: 74px; }\n  .dr-title { font-size: 14px; }\n  .dr-revenue-val { font-size: 20px; }\n  .dr-tile-number { font-size: 17px; }\n  .dr-call-orb { width: 70px; height: 70px; }\n  .dr-orb-ring { width: 88px; height: 88px; }\n  .dr-orb-icon svg { width: 30px; height: 30px; }\n  .dr-bot-image { width: 84px; }\n  .dr-bot-container { padding: 0 12px 8px; }\n}\n\n@media (max-height: 600px) {\n  .dr-logo { width: 62px; }\n  .dr-subtitle { display: none; }\n  .dr-revenue-val { font-size: 18px; }\n  .dr-kpi-tile { padding: 6px 8px; }\n  .dr-tile-number { font-size: 15px; }\n  .dr-call-orb { width: 60px; height: 60px; }\n  .dr-orb-ring { width: 76px; height: 76px; }\n  .dr-orb-icon svg { width: 26px; height: 26px; }\n  .dr-bot-container { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
